<div class="fieldset-wrapper multiple-dropdown" id="Q{{firstQuestion?.qno}}_{{firstQuestion?.UniqueNumber}}_RW" *ngIf="questions.length > 0">
 <div *ngIf="imgQuestion?.QuestionImageAndMedia_1 != null" class="questionImageWrapper" [ngClass]="{'question-border': !isMobile}">
    <app-question-image-and-media [questionImageAndMedias]="imgQuestion?.QuestionImageAndMedia_1"
      [imageSize]="imgQuestion?.ImageSize" [isMobile]="isMobile">
    </app-question-image-and-media>
  </div>

  <fieldset>
    <legend class="question-option-wrapper" [ngClass]="{'question-border': imgQuestion.QuestionImageAndMedia_1 == null && !isMobile}">
      <span *ngIf="isDisplayQno" class="question-no">{{firstQuestion.qno}}.</span>
      <!-- <span [ngClass]="(group.isOverAllStyleApplied) ? 'question-text' : 'question-text-nb'" id="lbltitle_RW{{firstQuestion?.UniqueNumber}}"> -->
      <span  [ngClass]="{'question-text' : ((group.isOverAllStyleApplied && matrix.isMulti) || (matrix.isOverAllStyleApplied && !matrix.isMulti)),
        'question-text-nb': ((!group.isOverAllStyleApplied && matrix.isMulti) || (!matrix.isOverAllStyleApplied && !matrix.isMulti)),
        'no-Qno':!isDisplayQno}" id="lbltitle_RW{{firstQuestion?.UniqueNumber}}">
        <span *ngIf="questions[0].piping"[innerHTML]="getPipingTitle(questions[0]?.group_no) | headerFooterHtml"></span>
        <span *ngIf="!questions[0].piping" [innerHTML]="group?.gtitle | headerFooterHtml"></span>
        <span *ngIf="group?.QuestionTip" class="tooltip_icon" appTooltip [dataContext]="group?.QuestionTip"
          [IsButtonPanel]="false" [qid]="firstQuestion?.UniqueNumber" tabindex="0" ></span>
          <div *ngIf="imgQuestion?.hasMedia && imgQuestion?.MediaText != null && imgQuestion?.MediaText != ''" class="question-media-text">
            <span>[{{imgQuestion?.MediaText}}]</span>
          </div>
        </span>
    </legend>

    <div *ngIf="imgQuestion?.QuestionImageAndMedia_2 != null" class="questionImageWrapper">
      <app-question-image-and-media [questionImageAndMedias]="imgQuestion?.QuestionImageAndMedia_2"
        [imageSize]="imgQuestion?.ImageSize" [isMobile]="isMobile">
      </app-question-image-and-media>
    </div>

    <div *ngIf="isMDD; else RatingDropDownGrid">
      <div class="fieldset-wrapper-scroll-cont" *ngIf="!isMobile">
        <div class="div-scroll-btn"><span class="div-scroll-symbol"></span></div>
        <div class="fieldset-wrapper-scroll">
          <div style="display: table; width: 100%;" class="answerParent">
            <div class="answer-option-wrapper mdd-box">
              <div *ngIf="matrix?.MultiColumnCount > 1; else SingleColumnCode">
                <div class="column-struct-mdd" *ngFor="let questions of questionsArray">
                  <table cellpadding="0" cellpadding="3" role="presentation">
                    <tr class="" *ngFor="let questions of questions">
                      <!-- it shows horizontal and vertical data-->
                      <td class="mdd-td" *ngFor="let question of questions; let i = index">
                        <div *ngIf="question.qtype == 'RW'" class="mdd-wrapper multiCol">
                          <app-drop-down [JsonData]="GetQuestionsString(question)" [isDisplayQno]="false" [isMDD]="true" [isNonSearchable]="false"
                            [isDisplaySubQno]="GetSubQnNumber()"
                            [isMandatoryUpfront]="isMandatoryUpfront"
                            [isAnySubQMandatory]="isAnySubQMandatory"
                            [DropDown]="DropDown"
                            [dropDownlength]="dropDownlength"
                            [isStandAlone]="isMobile"
                            (ChangeAnswersData)="UpdateQuestionsData($event)">
                          </app-drop-down>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <ng-template #SingleColumnCode>
                <div *ngFor="let question of questions | callBack: getHiddenQuestions">
                  <div *ngIf="question.qtype == 'RW'" class="mdd-wrapper singleCol">
                    <app-drop-down [JsonData]="GetQuestionsString(question)" [isDisplayQno]="false"
                      [isDisplaySubQno]="isDisplayQno" [isMDD]="true" [isNonSearchable]="false"
                      [isMandatoryUpfront]="isMandatoryUpfront"
                      [isAnySubQMandatory]="isAnySubQMandatory"
                      [DropDown]="DropDown"
                      [dropDownlength]="dropDownlength"
                      [isStandAlone]="isMobile"
                      (ChangeAnswersData)="UpdateQuestionsData($event)">
                    </app-drop-down>
                  </div>
                </div>
              </ng-template>
              <ng-container *ngIf="isNewParticipation  && (surveyFormat == 1 || surveyFormat == 2)">
                <div  class="ques-response-btn-div">
                  <!-- <input type="button" value="{{newParticipationBtnText}}" class="ques-response-btn"
                    (click)="gotoNextQuestion(questions[0],$event.target)" /> -->
                    <button *ngIf="showNewParticipationButton && (isAnsChange||isPreReadQn)" type="button" class="ques-response-btn" (keyup.Space)="gotoNextQuestionKeyboard(questions,$event)" (click)="gotoNextQuestion(questions[0],$event.target)">{{newParticipationBtnText}}</button>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="isMobile">

        <div class='mdd-data' *ngFor="let question of questions | callBack: getHiddenQuestions; let i = index" [ngClass]="'mdd-data_' + question.group_no">

          <!-- Drop Down -->
          <div [hidden]="question.isCQ && question.isCQHide && question.isGroupRule" id="dv_{{question?.UniqueNumber}}"
            *ngIf="question.qtype =='GD'|| (question.qtype =='RW' && question.qsubtype == 2)" class="question-data mdd-question-data"
            [ngClass]="(isSubmitted && question.mandatory && question.AnswerText == null)  ? 'mandatory' : ''">
            <app-drop-down [JsonData]="GetQuestionsString(question)" [isDisplayQno]="false" [isDisplaySubQno]="isDisplayQno"
              [isAnySubQMandatory]="isAnySubQMandatory"
              [isMDD]="false" [isNonSearchable]="false" [dropDownlength]="dropDownlength"  [isGrid]="true"  [isMandatoryUpfront]="isMandatoryUpfront" [DropDown]="DropDown" [isStandAlone]="true"
              (ChangeAnswersData)="UpdateQuestionsData($event)">
            </app-drop-down>
          </div>
        </div>

        <ng-container *ngIf="isNewParticipation  && (surveyFormat == 1 || surveyFormat == 2)">
          <div  class="ques-response-btn-div">
            <!-- <input type="button" value="{{newParticipationBtnText}}" class="ques-response-btn"
              (click)="gotoNextQuestion(questions[0],$event.target)" /> -->
              <button *ngIf="showNewParticipationButton && (isAnsChange||isPreReadQn) && !(questions[0].qsubtype == 2 && this.service.isAutoScroll)" type="button" class="ques-response-btn" (keyup.Space)="gotoNextQuestionKeyboard(questions,$event)" (click)="gotoNextQuestion(questions[0],$event.target)">{{newParticipationBtnText}}</button>
          </div>
        </ng-container>
      </div>
    </div>
    <ng-template #RatingDropDownGrid>
      <ng-container *ngIf="!isDisplayedPipeMessage; else AnswerPipeMessage">
      <div class="fieldset-wrapper-scroll-cont" *ngIf="!isMobile">
        <div class="div-scroll-btn"><span class="div-scroll-symbol"></span></div>
        <div class="fieldset-wrapper-scroll">
          <div style="display: table; width: 100%;" class="answerParent">
            <div class="answer-option-wrapper matrix-grid main-matrix">
              <table [style.width]="totalWidth + 'px'" role="presentation" style="width: 100%;" cellpadding="0" cellspacing="0">

                <tr *ngFor="let question of questions | callBack: getHiddenQuestions; let i = index; let odd=odd; let even=even;" [ngClass]="{'odd-row' : odd, 'even-row':even,'rddgMand' : (question.mandatory && isMandatoryUpfront) || (question.mandatory && isSubmitted)}">
                  <td *ngIf="matrix.QPos == 0" [style.width]="mainQuestionWidth + 'px'" style="position: relative; padding: 15px 0px;" class="matrixTitleTd">
                    <span  class='rddg-subqno' *ngIf="isDisplayQno" style="display: inline-block; margin: 0 3px">{{question?.subQnoinChar}}</span>
                    <!-- <span id="rddg-subq-title-{{question.UniqueNumber}}">{{question.qtitle}}</span> -->
                    <span *ngIf="question.piping" class="rddg-subq-title" id="rddg-subq-title-{{question.UniqueNumber}}" [innerHTML]="question?.pipingQuationTitle | headerFooterHtml"></span>
                    <span *ngIf="!question.piping" class="rddg-subq-title" id="rddg-subq-title-{{question.UniqueNumber}}" [innerHTML]="question?.qtitle | headerFooterHtml"></span>

                    <div *ngIf="(question.mandatory && isMandatoryUpfront) || (question.mandatory && isSubmitted)">
                      <div class="isMandatory matrix-grid-mandatory">
                      </div>
                    </div>
                  </td>
                  <td style="padding: 0 15px 3px;" class="rddg-grid-border grid-hover" [style.width]="subQuestionWidth + 'px'"
                  [ngClass]="(isSubmitted && question.mandatory && !question.IsDisabled && question.AnswerText == null) ? 'matrix-border' : ''"
                  [ngStyle]="{'pointer-events' : question.population_type == 3 ? 'none':''}" >
                  <!-- Drop Down -->

                    <table role="presentation" style="position: relative;" [style.zIndex] = "(questions.length - i)">
                      <tr *ngIf="i == 0">
                        <td class="answer-option">
                        </td>
                      </tr>
                      <tr>
                        <td class="answer-option" style="padding: 5px 0px 5px;">
                          <div *ngIf="question?.population_type != 3 else PreReadPopulation">
                            <div class="custom-select-wrapper" *ngIf="question?.Answers.length < MDDdropDownCount">
                              <div _ngcontent-xlf-c17="" class="arr">
                                <div _ngcontent-xlf-c17="" class="arr-symbol"></div>
                              </div>
                              <select (change)="DropDownSelectedValue($event, question,false);nextQuestion($event.target)" [(ngModel)]=question.selectAnsValue
                                [disabled]="question.IsDisabled" [attr.aria-labelledby]="'rddg-subq-title-'+question.UniqueNumber"
                                [attr.aria-required]="(question.mandatory && isMandatoryUpfront) || (question.mandatory && isSubmitted)">
                                <option [value]="-1" selected [innerHTML]="DropDown  | headerFooterHtml"></option>
                                <option *ngFor="let answers of question?.Answers" [hidden]="answers?.isHide"
                                  [value]="answers.value_id">
                                  <span  [innerHTML]="answers.value_text  | headerFooterHtml"></span>
                                </option>
                              </select>
                            </div>

                            <div id="dv_RDDG_{{question.UniqueNumber}}" class="custom-select-wrapper drill-down-search" *ngIf="question?.Answers.length >= MDDdropDownCount">
                              <div class="arr" (click)="showDDList($event)">
                                <div class="arr-symbol"></div>
                              </div>
                              <input type="text" class="drill-down-input drill-down-input-{{question.UniqueNumber}}"   placeholder="{{surveyMessages.Search}}" (keydown)="filterDDSearch($event, question)" (click)="filterDDSearch($event, question)"
                                (change)="filterDDSearch($event, question)" (blur)="setDDListItem($event, question)" (focus)="setPrevValue($event)"
                                [(ngModel)]=question.AnswerText [attr.aria-labelledby]="'rddg-subq-title-'+question.UniqueNumber" aria-label="Search"
                                role="combobox" aria-haspopup="true" [attr.aria-owns]="'dropdown_list_' + question.UniqueNumber "
                                aria-expanded="false" (keydown.esc)="closeDDList($event);" (keydown.alt.arrowdown)="showDDList($event);" />
                              <div id="dropdown_list_{{question.UniqueNumber}}" class="drill-down-list"
                                style="max-height: 70px; overflow: auto; z-index: 1000; text-align: left;"
                                role="listbox" [attr.aria-labelledby]="'rddg-subq-title-'+question.UniqueNumber">
                                <div class="drill-down-list-item" *ngFor="let answers of question?.Answers" [attr.list-value]="answers.value_id"
                                  [ngClass]="{'ddItemHidden':answers?.isHide}" (mousedown)="selectDDListItem($event, question)"
                                  [attr.ogListValue]="answers.value_text">
                                  {{answers.value_text}}
                                </div>
                              </div>
                              <select (change)="DropDownSelectedValue($event, question,false)" [(ngModel)]=question.selectAnsValue
                              [attr.aria-labelledby]="'rddg-subq-title-'+question.UniqueNumber" aria-hidden="true" tabindex="-1">
                                <option [innerHTML]="DropDown | headerFooterHtml" [value]="-1" selected>

                                </option>
                                <option *ngFor="let answers of question?.Answers" [hidden]="answers?.isHide" [value]="answers.value_id">
                                  <span [innerHTML]="answers.value_text | headerFooterHtml" ></span>
                                </option>
                              </select>
                            </div>
                            <div style="display: none;" class="drill-down-list-itemMessage_{{question?.UniqueNumber}} drill-down-list-itemMessage"><span>{{Nomatchfound}}</span></div>
                          </div>
                          <ng-template #PreReadPopulation>
                            <div class="answer-option DropDown-read-only radio">
                              <div>
                                    <span class="answer-text">{{question?.PrePopText}}</span>
                              </div>
                            </div>
                          </ng-template>
                        </td>
                      </tr>
                    </table>
                  </td>
                  <td *ngIf="matrix.QPos != 0" [style.width]="mainQuestionWidth + 'px'" style="position: relative; padding: 15px 0px;" class="matrixTitleTd">
                    <span class='rddg-subqno' *ngIf="isDisplayQno">{{question?.subQnoinChar}}</span>
                    <!-- <span id="rddg-subq-title-{{question.UniqueNumber}}">{{question.qtitle}}</span> -->
                    <span *ngIf="question.piping"  class="rddg-subq-title" id="rddg-subq-title-{{question.UniqueNumber}}" [innerHTML]="question?.pipingQuationTitle | headerFooterHtml"></span>
                    <span *ngIf="!question.piping" class="rddg-subq-title" id="rddg-subq-title-{{question.UniqueNumber}}" [innerHTML]="question?.qtitle | headerFooterHtml"></span>
                    <div *ngIf="(question.mandatory && isMandatoryUpfront) || (question.mandatory && isSubmitted)">
                      <div class="isMandatory matrix-grid-mandatory">
                      </div>
                    </div>
                  </td>
                  <div *ngIf="isNgOnChange && ngCount == 1 && i == questions.length -1">{{ngAfterHandle()}}</div>
                </tr>
              </table>
              <ng-container *ngIf="isNewParticipation  && (surveyFormat == 1 || surveyFormat == 2)">
                <div  class="ques-response-btn-div">
                  <!-- <input type="button" value="{{newParticipationBtnText}}" class="ques-response-btn"
                    (click)="gotoNextQuestion(questions[0],$event.target)" /> -->
                    <button *ngIf="showNewParticipationButton && (isAnsChange||isPreReadQn)" type="button" class="ques-response-btn" (keyup.Space)="gotoNextQuestionKeyboard(questions,$event)" (click)="gotoNextQuestion(questions[0],$event.target)">{{newParticipationBtnText}}</button>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isMobile">

        <div class="mdd-data" *ngFor="let question of questions | callBack: getHiddenQuestions; let i = index" [ngClass]="'mdd-data_' + question.group_no">

          <!-- Drop Down -->
          <div [hidden]="question.isCQ && question.isCQHide && question.isGroupRule" id="dv_{{question?.UniqueNumber}}"
            *ngIf="question.qtype =='GD'|| (question.qtype =='RW' && question.qsubtype == 2)" class="question-data mdd-question-data"
            [ngClass]="(isSubmitted && question.mandatory && question.AnswerText == null)  ? 'mandatory' : ''">
            <app-drop-down [JsonData]="GetQuestionsString(question)" [isDisplayQno]="false" [isDisplaySubQno]="isDisplayQno"
              [isAnySubQMandatory]="isAnySubQMandatory"
              [isMDD]="false" [isNonSearchable]="false" [isGrid]="true" [isMandatoryUpfront]="isMandatoryUpfront" [DropDown]="DropDown"
              (ChangeAnswersData)="UpdateQuestionsData($event)" [dropDownlength]="dropDownlength" [isStandAlone]="true">
            </app-drop-down>
          </div>
        </div>

        <ng-container *ngIf="isNewParticipation  && (surveyFormat == 1 || surveyFormat == 2)">
          <div  class="ques-response-btn-div">
            <!-- <input type="button" value="{{newParticipationBtnText}}" class="ques-response-btn"
              (click)="gotoNextQuestion(questions[0],$event.target)" /> -->
              <button *ngIf="showNewParticipationButton && (isAnsChange||isPreReadQn) && !(questions[0].qsubtype == 2 && this.service.isAutoScroll)" type="button" class="ques-response-btn" (keyup.Space)="gotoNextQuestionKeyboard(questions,$event)" (click)="gotoNextQuestion(questions[0],$event.target)">{{newParticipationBtnText}}</button>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-template #AnswerPipeMessage>
      <span [innerHTML]="getAnswerPipeMessage() | headerFooterHtml" class="hidden-message"></span>
    </ng-template>
    </ng-template>
  </fieldset>
</div>
